import Vue from 'vue'
// import moment from 'moment-timezone'
// initial state
const state = {
  instanceID: null,
  lastBindedInstanceID: null,
  isEmpty: {},
  instance: {},
  persons: [],
  populations: [],
  personsIndexes: {},
  lastDaysSymptoms: {},
  populationHistory: {},
  administratorPhoneNumbers: [],
  accessPointsPhoneNumbers: [],
  observerPhoneNumbers: [],
  accessPoints: [],
  documentIDtoCreate: '',
  selectedPersons: {},
  tagManagerProps: {},
  lastTableProp: '',
  newTableProp: null,
  isCreating: false,
  tableSort: null,
  variants: null,
  firmwareList: null,
}

// getters
const getters = {
  parsedFirmwareList (state) {
    return state.firmwareList ? state.firmwareList.map(firmware => {
      return {
        id: firmware.id,
        ...firmware.data(),
      }
    }) : []
  },
  tags (state) {
    return state.instance.tags || {}
  },
}

// actions
const actions = {
}

function recalcutaleIndexes (state) {
  const indexes = {}
  for (const [index, person] of state.persons.entries()) {
    indexes[person.id] = index
  }
  return indexes
}

// mutations
const mutations = {
  addPersons (state, personsToAdd) {
    if (personsToAdd[Object.keys(personsToAdd)[0]].oldIndex === 0) {
      state.persons = Object.keys(personsToAdd).map(personID => personsToAdd[personID].personData)
    } else {
      state.persons = [...Object.keys(personsToAdd).map(personID => personsToAdd[personID].personData), ...state.persons]
    }
    state.personsIndexes = recalcutaleIndexes(state)
  },
  editPersons (state, personsToEdit) {
    for (const personID of Object.keys(personsToEdit)) {
      const person = personsToEdit[personID]
      Vue.set(state.persons, state.personsIndexes[personID], person.personData)
      if (state.personsIndexes[personID] !== person.newIndex) {
        state.personsIndexes = recalcutaleIndexes(state)
      }
    }
  },
  deletePerson (state, person) {
    Vue.delete(state.persons, person.oldIndex)
    state.personsIndexes = recalcutaleIndexes(state)
  },
  setTagManagerProps (state, props) {
    state.tagManagerProps = props
  },
  selectPerson (state, personID) {
    Vue.set(state.selectedPersons, personID, true)
  },
  removeSelectedPerson (state, personID) {
    Vue.delete(state.selectedPersons, personID)
  },
  clearSelectedPersons (state) {
    state.selectedPersons = {}
  },
  setDocumentIDtoCreate (state, data) {
    state.documentIDtoCreate = data
  },
  setPopulationHistory (state, data) {
    state.populationHistory = data
  },
  setSpecificPopulationHistory (state, obj) {
    if (obj.data[obj.populationID]) {
      Vue.set(state.populationHistory, obj.populationID, obj.data[obj.populationID])
    }
  },
  setVariants (state, data) {
    state.variants = data
  },
  setFirmwareList (state, data) {
    state.firmwareList = data
  },
  deleteLastSymptomsDay (state, result) {
    state.lastDaysSymptoms = {}
  },
  setLastSymptomsDay (state, result) {
    Vue.set(state.lastDaysSymptoms, result.id, result.data)
  },
  setProp (state, obj) {
    state[obj.prop] = obj.val
  },
  setPersons (state, persons) {
    state.persons = persons
  },
  setPopulations (state, populations) {
    state.populations = populations
  },
  setPersonsIndexes (state, personsIndexes) {
    state.personsIndexes = personsIndexes
  },
  setInstance (state, instance) {
    if (state.instanceID !== state.lastBindedInstanceID) {
      state.persons = []
      state.populations = []
      state.personsIndexes = {}
      state.lastDaysSymptoms = {}
      state.populationHistory = {}
      state.administratorPhoneNumbers = []
      state.accessPointsPhoneNumbers = []
      state.accessPoints = []
      state.lastBindedInstanceID = state.instanceID
    }
    state.instance = instance
  },
  setInstanceTags (state, tags) {
    state.instance.tags = tags
  },
  setInstanceID (state, instanceID) {
    if (state.instanceID !== instanceID) {
      Vue.set(state, 'instanceID', instanceID)
    }
  },
  setIsEmpty (state, obj) {
    Vue.set(state.isEmpty, obj.type, obj.val)
  },
  setAdministratorPhoneNumbers (state, obj) {
    state.administratorPhoneNumbers = obj
  },
  setObserverPhoneNumbers (state, obj) {
    state.observerPhoneNumbers = obj
  },
  setAccessPointsPhoneNumbers (state, obj) {
    state.accessPointsPhoneNumbers = obj
  },
  setLastTableProp (state, obj) {
    if (state.newTableProp !== null) {
      state.lastTableProp = state.newTableProp
    }
    state.newTableProp = obj
  },
  setTableSort (state, sort) {
    state.tableSort = sort
  },
  setIsCreating (state, obj) {
    state.isCreating = obj
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
